import React, {
	Component
} from 'react';

import styled from 'styled-components';
import { motion } from 'framer-motion';
//import { Sprite } from './Sprite';
import { B64Image } from './B64Image';
import { ButtonMover } from './Buttons';
import { store } from '../stores/mainStore';

const AvaBody = styled.div`
	position: absolute;
	bottom: -20vw;
	left: -10vw;
	width: 110vw;
	& > img {
		width: 52vw;
		pointer-events: none;
		.Tall & {
			width: 57.2vw;
		}
	}
	.Tall &.tutorial > img {
		width: 62.92vw;
	}
	&.firstPlayLobby{
		top: 20vw;
		& > img {
			width: 50vw;
		}
	}
`
const BubbleBody = styled.div`
	position: absolute;
	top: 0vw;
	right: 3vw;
	display: flex;
	flex-direction: column;
	align-items: center;
`

export class AvaRules extends Component {
	render(){
		return (
			<AvaBody className={this.props.className}>
				<motion.div
					initial={{scale: 0}}
					animate={{scale: 1}}
					transition={{duration: 0.3, delay: 0.5}}
				>
					<BubbleBody>
						<img alt="" style={{width: '63vw'}} src="/assets/rules/1_turn_how_to_play.png"/>
						<ButtonMover onClick={() => { store.firstTimeRules = false; }}>
							<img alt="" style={{marginTop: '3vw', width: '33vw'}} src="/assets/rules/btn_1_turn_ok.png"/>
						</ButtonMover>
					</BubbleBody>
				</motion.div>
				{/* <Bubbles>
					{this.props.children  && this.props.children[this.bubble]}
				</Bubbles> */}
				<B64Image draggable="false" alt="Ava" src="/assets/lobby/game_lobby_ava.png"/>
			</AvaBody>
		)
	}
}
